import { render, staticRenderFns } from "./blogs-10.vue?vue&type=template&id=4b1eb8c6&scoped=true"
import script from "./blogs-10.vue?vue&type=script&lang=js"
export * from "./blogs-10.vue?vue&type=script&lang=js"
import style0 from "./blogs-10.vue?vue&type=style&index=0&id=4b1eb8c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1eb8c6",
  null
  
)

export default component.exports